import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { connectionString } from './connectionString.js';

export const reactPlugin = new ReactPlugin();

let appInsights = null;

export function initAppInsights({ history } = {}) {
  if (appInsights) return appInsights;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableUnhandledPromiseRejectionTracking: true,
      autoTrackPageVisitTime: false,
      enableAjaxErrorStatusText: true,
      // Don't inject `Request-Id` / `traceparent` headers into cross-origin
      // requests — third-party APIs (Giphy, Unsplash, etc.) don't whitelist
      // them in CORS, so the browser blocks the preflight.
      enableCorsCorrelation: false,
      disableCorrelationHeaders: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history },
      },
    },
  });

  appInsights.loadAppInsights();

  // Drop telemetry that targets App Insights itself — prevents feedback loops
  // when the ingest endpoint fails and the SDK turns those failures into new
  // exceptions/dependencies, which would be sent again, ad infinitum.
  appInsights.addTelemetryInitializer((envelope) => {
    const data = envelope?.baseData || {};
    const url = data.target || data.uri || data.name || '';
    if (typeof url === 'string' && url.includes('applicationinsights.azure.com')) {
      return false;
    }
    return true;
  });

  appInsights.trackPageView();

  return appInsights;
}

export const getAppInsights = () => appInsights;
export { withAITracking };
